import React from "react";
import "../../components/subscription/subscription.css";
import Head from "../Header/head";
import "../../common/css/common.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

function Subscription(){

    const navigate = useNavigate()
    const login = useSelector((state)=>state.jwtAuthreducer)
    const subscribe = (type)=>{
        if(login.isAuthenticated){
            navigate("/checkout",{state:{plan_type:type}})
            
        }
        else{
            navigate("/login")

        }    
    }

    return(
        <div>
            <Head/>
            <div className="inner-page-wrapper">
            <div className="step-header">
                <div className="container d-flex">
                    <div className="step-header-title">
                        Subscription Plan
                    </div>
                </div>
            </div>

            <div className="form-step ">
            <div class="subscription-plans">
            <div class="plan-container">
                <div class="plan">
                    <h2>Starter</h2>
                    <p>- Works for debate with almost no rule</p>
                    <p>- Upto 12 Debates</p>
                    <p>- Unlimited Audience</p>
                    <p>- Voting</p>
                    <p>- Price: $15/month</p>
                <span onClick={()=>subscribe("starter")} class="subscribe-button">Subscribe</span>
                   
                </div>
                <div class="plan">
                    <h2>Pro</h2>
                    <p>- Best for competitions and advanced debates</p>
                    <p>- Upto 12 Debates</p>
                    <p>- Unlimited Audience</p>
                    <p>- Voting</p>
                    <p>- Scoring</p>
                    <p>- Topic Selection</p>
                    <p>- Include more structuring options</p>
                    <p>- More oraganization Options</p>
                    <p>- Also includes starter and intermediate style</p>
                    <p>- Price: $25/month</p>
                    <span onClick={()=>subscribe("pro")} class="subscribe-button">Subscribe</span>
                </div>
                <div class="plan">
                    <h2>Intermediate</h2>
                    <p>- Better for more organized debates</p>
                    <p>- Upto 12 debates</p>
                    <p>- Unlimited Audience</p>
                    <p>- Voting</p>
                    <p>- Topic Selection</p>
                    <p>- Mediator can set time limit on each side</p>
                    <p>- Also include starter style</p>
                    <p>Price: $20/month</p>
                    <span onClick={()=>subscribe("intermediate")} class="subscribe-button">Subscribe</span>
                </div>
            </div>
            </div>
            </div>
            </div>

        </div>
    );
}

export default Subscription;